import { makeStyles } from "@material-ui/core/styles";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import Skeleton from "@saleor/components/Skeleton";
import React from "react";

export interface OrderLineStatusProps {
  status: string;
}

const useStyles = makeStyles(
  theme => {
    const dot = {
      borderRadius: "100%",
      content: "''",
      display: "inline",
      height: "10px",
      marginLeft: "8px",
      marginTop: "6px",
      position: "absolute" as "absolute",
      width: "10px"
    };

    const smDotDown = {
      borderRadius: "100%",
      content: "''",
      display: "inline",
      height: "10px",
      marginLeft: "8px",
      marginTop: "2px",
      position: "absolute" as "absolute",
      width: "10px"
    };

    return {
      dotOutOfStock: {
        "&:before": { backgroundColor: "#E72531", ...dot },
        [theme.breakpoints.down("sm")]: {
          "&:before": { backgroundColor: "#E72531", ...smDotDown }
        }
      },
      dotPicked: {
        "&:before": { backgroundColor: "#63D6B7", ...dot },
        [theme.breakpoints.down("sm")]: {
          "&:before": { backgroundColor: "#63D6B7", ...smDotDown }
        }
      },
      dotPicking: {
        "&:before": { backgroundColor: "#FFD15C", ...dot },
        [theme.breakpoints.down("sm")]: {
          "&:before": { backgroundColor: "#FFD15C", ...smDotDown }
        }
      },
      orderStatuslabel: {
        fontWeight: 600,
        paddingRight: "11px"
      },
      statusOutOfStock: {
        backgroundColor: "#F8BEC1",
        borderRadius: "25px",
        display: "inline",
        padding: "6px"
      },
      statusPickedLabel: {
        backgroundColor: "#C3F2E9",
        borderRadius: "25px",
        display: "inline",
        padding: "6px"
      },
      statusPickingLabel: {
        backgroundColor: "#FFF6DE",
        borderRadius: "25px",
        display: "inline",
        padding: "6px"
      }
    };
  },
  { name: "OrderLineStatus" }
);

const OrderLineStatus: React.SFC<OrderLineStatusProps> = props => {
  const { status } = props;
  const classes = useStyles(props);

  const checkStatus = () => {
    switch (status) {
      case "PICKING":
        return (
          <div className={classes.statusPickingLabel}>
            <FiberManualRecordIcon
              style={{ color: "#FFD15C", marginBottom: "-6px" }}
            />
            <span className={classes.orderStatuslabel}>Picking</span>
          </div>
        );

      case "PICKED":
        return (
          <div className={classes.statusPickedLabel}>
            <FiberManualRecordIcon
              style={{ color: "#63D6B7", marginBottom: "-6px" }}
            />
            <span className={classes.orderStatuslabel}>Picked</span>
          </div>
        );
      case "OUT_OF_STOCK":
        return (
          <div className={classes.statusOutOfStock}>
            <FiberManualRecordIcon
              style={{ color: "#E72531", marginBottom: "-6px" }}
            />
            <span className={classes.orderStatuslabel}>Out Of Stock</span>
          </div>
        );
      default:
        return <Skeleton />;
    }
  };

  return checkStatus();
};

export default OrderLineStatus;
